import { Layer } from "./Layer";
;
export class DataListener extends Layer {
    constructor(config) {
        super([]);
        this.dataObjects = Object.create(null);
        this.pathKeyMapping = Object.create(null);
        this.config = config;
        if (this.config.keyMapping === undefined) {
            this.config.keyMapping = () => undefined;
        }
    }
    activate() {
        if (this.isListPathListenConfig(this.config.listen)) {
            //console.log(`Listening for list path ${this.config.listen.listPath} with firebase ${this.config.firebase.constructor.name}`);
            this.config.firebase.onChildAdded(this.config.listen.listPath, (snap) => {
                const path = this.getListPathFor(snap.key);
                if (snap.exists() && snap.val() !== undefined && snap.val() !== null) {
                    const key = this.getKey(path, snap.val());
                    this.dataObjects[key] = snap.val();
                    //console.log(`${key} created: ${snap.val()}`);
                    this.sendUpdate({
                        type: 'Created',
                        key,
                        oldData: null,
                        newData: this.dataObjects[key],
                    });
                }
            });
            this.config.firebase.onChildChanged(this.config.listen.listPath, (snap) => {
                const path = this.getListPathFor(snap.key);
                if (snap.exists() && snap.val() !== undefined && snap.val() !== null) {
                    const key = this.getKey(path, snap.val());
                    const oldData = this.dataObjects[key];
                    this.dataObjects[key] = snap.val();
                    //console.log(`${key} updated: ${snap.val()}`);
                    this.sendUpdate({
                        type: 'Updated',
                        key,
                        oldData,
                        newData: this.dataObjects[key],
                    });
                }
            });
            this.config.firebase.onChildRemoved(this.config.listen.listPath, (snap) => {
                const path = this.getListPathFor(snap.key);
                //console.log(`onChildRemoved. Path: ${(this.config.listen as any).listPath}, snap exists: ${snap.exists()}, val: ${snap.val()}`);
                if (snap.exists() && snap.val() !== undefined && snap.val() !== null) {
                    const key = this.getKey(path, snap.val());
                    //console.log(`Key: ${key}, this.dataObjects[key]: ${this.dataObjects[key]}`);
                    if (this.dataObjects[key] !== undefined) {
                        const oldData = this.dataObjects[key];
                        delete this.dataObjects[key];
                        //console.log(`${key} deleted: ${snap.val()}`);
                        this.sendUpdate({
                            type: 'Deleted',
                            key,
                            oldData,
                            newData: null,
                        });
                    }
                }
            });
        }
        else {
            for (const path of this.config.listen.paths) {
                //console.log(`Listening for ${path}`);
                this.config.firebase.onValue(path, (snap) => {
                    var _a;
                    //console.log(`Received snap for ${path}`);
                    if (snap.exists() && snap.val() !== undefined && snap.val() !== null) {
                        const key = this.getKey(path, snap.val());
                        if (this.dataObjects[key] === undefined) {
                            this.dataObjects[key] = snap.val();
                            //console.log(`${key} created: ${snap.val()}`);
                            this.sendUpdate({
                                type: 'Created',
                                key,
                                oldData: null,
                                newData: this.dataObjects[key],
                            });
                        }
                        else {
                            const oldData = this.dataObjects[key];
                            this.dataObjects[key] = snap.val();
                            //console.log(`${key} updated: ${snap.val()}`);
                            this.sendUpdate({
                                type: 'Updated',
                                key,
                                oldData,
                                newData: this.dataObjects[key],
                            });
                        }
                    }
                    else {
                        const key = (_a = this.pathKeyMapping[path]) !== null && _a !== void 0 ? _a : path;
                        //console.log(`${key} deleted`);
                        if (this.dataObjects[key] !== undefined) {
                            const oldData = this.dataObjects[key];
                            delete this.dataObjects[key];
                            this.sendUpdate({
                                type: 'Deleted',
                                key,
                                oldData,
                                newData: null,
                            });
                        }
                    }
                });
            }
        }
    }
    // No update fn because this is a root layer.
    update() {
        return null;
    }
    close() { }
    getLayerData() {
        return this.dataObjects;
    }
    getKey(path, data) {
        var _a;
        const key = (_a = this.config.keyMapping(path, data)) !== null && _a !== void 0 ? _a : path;
        this.pathKeyMapping[key] = key;
        return key;
    }
    getListPathFor(key) {
        return `${this.config.listen.listPath}/${key}`;
    }
    isListPathListenConfig(config) {
        return 'listPath' in config;
    }
}
//# sourceMappingURL=DataListener.js.map